// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"myLinkItem_linkItem__o35DU","icon":"myLinkItem_icon__xC_io","firstItem":"myLinkItem_firstItem__GMSiF"};